import { render, staticRenderFns } from "./FirstBookWorkspace.vue?vue&type=template&id=0516cab4&scoped=true&"
import script from "./FirstBookWorkspace.vue?vue&type=script&lang=js&"
export * from "./FirstBookWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./FirstBookWorkspace.vue?vue&type=style&index=0&id=0516cab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516cab4",
  null
  
)

export default component.exports